import React from 'react'
import {useIntl} from 'react-intl'
import {Navigate, Outlet, Route, Routes} from 'react-router-dom'
import {ClientSourcesListPage} from './pages/ClientSourcesListPage'
import {ClientEtablissements} from './pages/clientSources/ClientEtablissements'
import {ClientSourcesShowPage} from './pages/ClientSourcesShowPage'


const ClientSourcesWrapper = () => {
    const intl = useIntl()
    return (
        <>
            <Routes>
                <Route
                    path='liste'
                    element={
                        <>
                            <ClientSourcesListPage />
                        </>
                    }
                />

                <Route
                    path=':clientId/afficher/*'
                    element={
                        <>
                            <ClientSourcesShowPage />
                            <Outlet />
                        </>
                    }
                >
                    <Route
                        index
                        element={
                            <>
                                <ClientEtablissements />
                            </>
                        }
                    />
                </Route>
                
                <Route index element={<Navigate to='/vente/client-sources/liste' />} />
            </Routes>
        </>
    )
}

export {ClientSourcesWrapper}
